// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","info":"src-components-Footer----footer-module---info---3iULM","links":"src-components-Footer----footer-module---links---EXm1s","contact":"src-components-Footer----footer-module---contact---2nlVk","copyright":"src-components-Footer----footer-module---copyright---2FZFg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.scss
// module id = 318
// module chunks = 35783957827783